import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "batch-loader" }
const _hoisted_2 = { class: "batch-loader__file" }
const _hoisted_3 = { class: "label-xs n-drag-and-drop__label" }
const _hoisted_4 = {
  class: "batch-loader__dnd-link label-m",
  for: "files"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_6 = { class: "label-2xs n-drag-and-drop__label" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_8 = {
  class: "batch-loader__dnd-link label-m",
  for: "folder"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode()
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "batch-loader__form" }
const _hoisted_14 = { class: "batch-loader__results" }
const _hoisted_15 = { class: "batch-loader__statistics" }
const _hoisted_16 = { class: "label-m" }
const _hoisted_17 = { class: "batch-loader_selected" }
const _hoisted_18 = { class: "label-m" }
const _hoisted_19 = { class: "batch-loader_uploaded" }
const _hoisted_20 = { class: "label-m" }
const _hoisted_21 = { class: "batch-loader_errors" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButtonGroup = _resolveComponent("NButtonGroup")!
  const _component_NButton = _resolveComponent("NButton")!
  const _component_NAttachments = _resolveComponent("NAttachments")!
  const _component_NForm = _resolveComponent("NForm")!
  const _component_NLoadingProgress = _resolveComponent("NLoadingProgress")!
  const _component_BatchLoaderModalResult = _resolveComponent("BatchLoaderModalResult")!
  const _component_NModalWindow = _resolveComponent("NModalWindow")!

  return (_openBlock(), _createBlock(_component_NModalWindow, {
    layout: true,
    customSize: "1000px",
    "close-icon": true,
    "keyboard-close-disabled": "",
    onClose: _ctx.close
  }, _createSlots({
    header: _withCtx(() => [
      _createVNode(_component_NButtonGroup, {
        items: _ctx.dataAssetsModule.eventObjectTypeButtonItems,
        "model-value": _ctx.objectType,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = (v) => _ctx.setObjectType(v)),
        disabled: _ctx.loading
      }, null, 8, ["items", "model-value", "disabled"]),
      _createVNode(_component_NButton, {
        icon: "close",
        type: "secondary",
        round: "",
        onClick: _ctx.close
      }, null, 8, ["onClick"])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_NAttachments, {
              onAttach: _ctx.uploadDNDHandler,
              "disallow-attach": "",
              drag: "",
              "hide-amount": "",
              "hide-attachments": "",
              multiple: "",
              disabled: _ctx.attachDisabled
            }, {
              droparea: _withCtx(() => [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('common.drag_and_drop_files')), 1),
                _createElementVNode("div", {
                  onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                  class: "batch-loader__dnd-text"
                }, [
                  _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('cards.select_files')), 1),
                  _hoisted_5,
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('cards.or')), 1),
                  _hoisted_7,
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('cards.select_folder')), 1),
                  _createElementVNode("input", {
                    type: "file",
                    multiple: "",
                    id: "files",
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.uploadHandler && _ctx.uploadHandler(...args))),
                    class: "hide-element",
                    disabled: _ctx.attachDisabled
                  }, null, 40, _hoisted_9),
                  _hoisted_10,
                  _hoisted_11,
                  _createElementVNode("input", {
                    type: "file",
                    webkitdirectory: "",
                    id: "folder",
                    onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.uploadHandler && _ctx.uploadHandler(...args))),
                    class: "hide-element",
                    disabled: _ctx.attachDisabled
                  }, null, 40, _hoisted_12)
                ])
              ]),
              _: 1
            }, 8, ["onAttach", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_NForm, {
              ref: "itemForm",
              layout: _ctx.schema,
              model: _ctx.form,
              disabled: _ctx.loading
            }, null, 8, ["layout", "model", "disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          (_ctx.resultItems.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_NLoadingProgress, {
                  percent: _ctx.totalStatistics.progress,
                  errorPercent: _ctx.totalStatistics.errorPercent
                }, null, 8, ["percent", "errorPercent"]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createTextVNode(_toDisplayString(_ctx.$t('cards.selected', 'f')) + ": ", 1),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.resultItems.length), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createTextVNode(_toDisplayString(_ctx.$t('cards.uploaded', 'f')) + ": ", 1),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.totalStatistics.uploaded), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createTextVNode(_toDisplayString(_ctx.$t('cards.errors', 'f')) + ": ", 1),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.totalStatistics.errors), 1)
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultItems, (result) => {
                  return (_openBlock(), _createBlock(_component_BatchLoaderModalResult, {
                    key: result.file.fileName,
                    item: result,
                    "card-type": _ctx.cardType,
                    onOpenCard: _ctx.openCard
                  }, null, 8, ["item", "card-type", "onOpenCard"]))
                }), 128))
              ], 64))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 2
  }, [
    (!_ctx.finished)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["batch-loader__buttons", { 'batch-loader_fix': _ctx.resultItems.length }])
            }, [
              _createVNode(_component_NButton, {
                type: "primary",
                size: "big",
                onClick: _ctx.batchUpload,
                disabled: _ctx.resultItems.length === 0 || _ctx.loading
              }, {
                default: _withCtx(() => [
                  (_ctx.batchModule.paused)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('cards.continue', 'f')), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('cards.start', 'f')), 1)
                      ], 64))
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]),
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_NButton, {
                    key: 0,
                    type: "secondary",
                    size: "big",
                    onClick: _ctx.pauseUpload
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('cards.pause', 'f')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ], 2)
          ])
        }
      : undefined
  ]), 1032, ["onClose"]))
}